import media from './media';

enum common {
  naviHeight = '80px',
  headerHeight = '78px',
  boardContentMaxWidth = '800px',
}

// 추후 new color로 대체
enum color {
  perfectBlack = '#000000',
  black = '#212121',
  white = '#fff',
  perfectWhite = '#FFFFFF',
  gray = '#4D4D4D',
  gray2 = '#6D6D6D',
  gray3 = '#8D8D8D',
  gray4 = '#BDBDBD',
  silver = '#828282',
  red = '#FF466C',
  blue = '#0074CE',
  skyblue = '#3591E2',
  selected = '#9cd1ff',
  mint = '#15B186',
  yellow = '#FEBF2D',
  yellow2 = '#f9e001',
  yellow3 = '#FFD23B',
  borderYellow = '#e5d014',
  scroll = '#B3B6C2',
  placeholder = '#CBCED5',
  disabled = '#BABCC2',
  alertDisabled = '#F0F0F0',
  background = '#EEF1F5',
  publicBoardTheme = skyblue,
  tag = '#2C83E9',
  post = tag,
  placeHolder = '#5A6089',

  mauve = '#EFF1FF',
  purple = '#5754e0',
  hoverButton = '#6E6CEF',
  semiLightPurple = '#D4D8F7',
  lightPurple = '#F5F6FF',
  darkGray = '#868686',
  inputHover = '#A4ACEB',
  border = '#C3C9F8',
  lightBorder = '#D2E0F3',
  green = '#0E9F0B',
  charcoalGray = '#4B586A',
  lightLavender = '#E9EBFF',
  lavender = '#A4A9CF',
  backgroundColor = '#FAFAFF',
  warningRed = '#DD3E3E',
}

// TODO: 주석 정리하기
enum newColor {
  // border
  border = '#C1D9F1',
  borderSlate = '#B3C1CF',

  // font
  font = '#253553', // 기본 폰트 색상
  twilight = '#54637F', // 미선택 탭 색상
  navBlue = '#006FD7',
  royalBlue = '#2264DC', // 텍스트 버튼
  oceanBlue = '#0A70C5', // 정답 색상

  // background
  bg = '#EBF2F8',
  clearSky = '#E9F3F9 ', // 셀렉트 박스 배색
  lightSkyBlue='#D0ECFD ', // 옵션 호버
  softSkyBlue = '#CDE3F8 ', // 탭 색상
  clearBlue = '#7DC9FF', // 테이블 헤드
  azureBlue = '#94D2FF', // + 버튼 색상
  skyMist = '#84C7F6 ',
  pearlBlue ='#E8F6FF', // 표의 even 색상, 그림 그래프 버튼영역 배경색
  scroll = '#DEDEDE',
  radioBg = '#5494E0',

  blueBtn = '#0080F8', // 체크박스, 그림그래프 임티 선택, 모달 버튼 색상
  closeBtn = '#F0F0F0',
  hoverBtn = '#1EA0FB',

  peachyPink = '#FFE1DF', // btn active
  softCoral = '#FFA29D', // btn hover

  // common
  mistyBlue = '#A0AEC2  ', // on
  midnightBlue = '#4B586A', // off, 복사 붙여넣기
  subInfo = '#A4B2C5',

  // 디지털교과서 컬러
  babyBlue = '#EBF3FF', // 상위 카테고리 background
  brightBlue = '#1D6EF7', // 상위 카테고리 선택 gradient color1
  cobaltBlue = '#3764E2', // 상위 카테고리 선택 gradient color2
  coolGray = '#9FAAB8', // 공학도구 포함된 콘텐츠 토글 off 색상
  electricBlue = '#29AEFF', // 섹션 부 설명 색상
  aquaGreen = '#2BC89B', // 학습 리스트 완료 색상
  brightAzure = '#317CEE', // 진행중 텍스트 색상
  paleAqua = '#EAF9FB', // 다시 학습하기 버튼 색상
  skyBreeze = '#3EAEFF', // 활동 목록 hove 색상
  lightGray ='#EEEEEE', // checkbox disabled color 색상
  silverGray = '#E2E2E2' // // checkbox disabled border 색상
}

enum fontFamily {
  // regular = 'NotoSansCJKR-Regular',
  // medium = 'NotoSansCJKR-Medium',
  // bold = 'NotoSansCJKR-Bold',

  /** 프리텐다드 폰트 추가 */
  black = 'Pretendard-Black',
  extraBold = 'Pretendard-ExtraBold',
  bold = 'Pretendard-Bold',
  semiBold = 'Pretendard-SemiBold',
  regular = 'Pretendard-Regular',
  medium = 'Pretendard-Medium',
  light = 'Pretendard-Light',
  etraLight = 'Pretendard-ExtraLight',
  thin = 'Pretendard-Thin',

  gilroyBold = 'Gilroy-Bold',
  gilroyLight = 'Gilroy-Light',

  gmarketLight = 'GmarketSans-Light',
  gmarketMedium = 'GmarketSans-Medium',
  gmarketBold = 'GmarketSans-Bold',
}

enum fontSize {
  xxxxLarge = '60px',
  xxxLarge = '50px',
  xxLarge = '34px',
  xLarge = '28px',
  large = '20px',
  medium = '16px',
  xMedium = '18px',
  small = '14px',
  xSmall = '12px',
}

const theme = {
  common,
  color,
  newColor, // 추후 color 대체 예정
  fontFamily,
  fontSize,
};

const mediaTheme = {
  common: {
    headerHeight: {
      lg: '60px',
    },
  },
  fontSize: {
    xxLarge: {
      xxl: '32px',
      lg: '28px',
      sm: '24px',
    },
    xLarge: {
      xxl: '26px',
      lg: '22px',
      sm: '18px',
    },
  },
};

const appendThemeStylesToHeadTag = () => {
  if (document.head) {
    const style = document.createElement('style');
    let innerText = 'body{';
    Object.entries(theme).forEach(([groupName, group]) => {
      Object.entries(group).forEach(([key, value]) => {
        innerText += `--${groupName}-${key}:${value};`;
        (group as any)[key] = `var(--${groupName}-${key})`;
      });
    });
    innerText += '}';

    const devices: any = {};
    Object.entries(mediaTheme).forEach(([groupName, group]) => {
      Object.entries(group).forEach(([key, sizes]) => {
        Object.entries(sizes).forEach(([size, value]) => {
          if (!devices[size]) devices[size] = [];
          devices[size].push(`--${groupName}-${key}:${value};`);
        });
      });
    });
    Object.entries(devices).forEach(([device, values]) => {
      innerText += (media as any)[device]`body{${(values as any).join('')}}`;
    });

    style.innerText = innerText;
    document.head.append(style);
  }
};

appendThemeStylesToHeadTag();
export default theme;
